/**
 * Browser API base.
 * Dev always uses Vite `/api` proxy (same origin) so httpOnly `wp_refresh` is first-party.
 * Absolute `VITE_API_URL` breaks cookie refresh under cross-origin / third-party cookie rules.
 * Prod/staging builds bake `VITE_API_URL` (sibling API host; cookie SameSite=lax).
 */
export const API_BASE = import.meta.env.DEV
  ? '/api'
  : String(import.meta.env.VITE_API_URL ?? '/api').replace(/\/$/, '') || '/api';
